import api from './config';

class TreatmentImagesApi {
    /**
     * Get all treatment images
     */
    static list() {
        return api.request({
            method: 'GET',
            url: '/treatment-images'
        });
    }
}

export default TreatmentImagesApi;
